import Api from "../../../services/Api";

const BASE_URL = "/service/iqevse-csms/policies/v1";

export const policyApi = {
  getAllPolicies: async () => {
    const response = await Api.get(`${BASE_URL}/getAllPolicies`);
    return response;
  },

  getPolicyById: async policyId => {
    const response = await Api.get(`${BASE_URL}/${policyId}`);
    return response;
  },

  createPolicy: async policyData => {
    const response = await Api.post(BASE_URL, policyData);
    return response;
  },

  updatePolicy: async (policyId, policyData) => {
    const response = await Api.put(`${BASE_URL}/${policyId}`, policyData);
    return response;
  },

  deletePolicy: async policyId => {
    const response = await Api.delete(`${BASE_URL}/${policyId}`);
    return response;
  },
};
